// @flow
import React, { useContext, type Node } from 'react';
import cx from 'classnames'
import { Box, StickyBottomHelper, AvailabilityTypes } from 'sarsaparilla';
import { LayoutControlContext } from './DetailedAvailabilityPageLayout'

type PropTypes = {
    children: Node,
}
const DetailedAvailabilityActions = ({
    children,
}: PropTypes) => {
    const {
        isMobileApp,
    } = useContext(LayoutControlContext);

    return (
        <StickyBottomHelper scrollingContainerId="per-availability-main">
            <Box className="per-availability-book-now">
                <Box className={cx('per-availability-book-now-content', {'mobile-app': isMobileApp})}>
                    {React.Children.map(children, child => {
                        if (React.isValidElement(child) && child.type === AvailabilityTypes && isMobileApp) {
                            return null;
                        }
                        return child;
                    })}
                </Box>
            </Box>
        </StickyBottomHelper>
    );
}

export default DetailedAvailabilityActions;
